import { isChunkLoadError, recoverFromChunkLoadError } from '@shared/utils/appUpdate';
import type { FC } from 'react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { isRouteErrorResponse, Link, useRouteError } from 'react-router';

export const NotFound: FC = () => {
  const error = useRouteError();
  const { t } = useTranslation();
  const isUpdateError = isChunkLoadError(error);

  useEffect(() => {
    if (isUpdateError) {
      recoverFromChunkLoadError();
    }
  }, [isUpdateError]);

  let errorMessage: string;

  if (isRouteErrorResponse(error)) {
    // error is type `ErrorResponse`
    errorMessage = error.data?.message || error.statusText;
  } else if (error instanceof Error) {
    errorMessage = error.message;
  } else if (typeof error === 'string') {
    errorMessage = error;
  } else {
    console.error(error);
    errorMessage = 'Unknown error';
  }

  if (isUpdateError) {
    return (
      <div id="error-page" className="flex flex-col gap-8 justify-center items-center h-screen">
        <span className="loading loading-spinner loading-lg text-primary" />
        <h1 className="text-4xl font-bold">
          {t('serviceWorker.updateDescription', { defaultValue: 'Updating App' })}
        </h1>
        <p>
          {t('serviceWorker.reloading', { defaultValue: 'Reloading to the latest version...' })}
        </p>
      </div>
    );
  }

  return (
    <div id="error-page" className="flex flex-col gap-8 justify-center items-center h-screen">
      <h1 className="text-4xl font-bold">{t('error.title')}</h1>
      <p>{t('error.subTitle')}</p>
      <p className="text-slate-400">
        <i>{errorMessage}</i>
      </p>
      <Link to="/" className="btn">
        {t('error.button')}
      </Link>
    </div>
  );
};
